import { render, staticRenderFns } from "./ScoreEditor.vue?vue&type=template&id=b68a2626&scoped=true&"
import script from "./ScoreEditor.vue?vue&type=script&lang=ts&"
export * from "./ScoreEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreEditor.vue?vue&type=style&index=0&id=b68a2626&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68a2626",
  null
  
)

export default component.exports